module.exports = __webpack_public_path__ + "static/img/u70082.63a0b331.png";